import React, { Component } from "react";
import { assets } from "../../assets";
import s from "./index.module.css"

export class CompanyLogo extends Component {
  render() {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={s.companyLogo}
        href="https://moonproduct.tech"
      >
        <img
          src={assets.MoonRounded}
          alt="MoonProduct Logo"
          className={s.logo}
        />
        <p className={s.text}>MoonProduct</p>
      </a>
    );
  }
}
